import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const AztecMainTemple = {
  id: "126",
  name: "Aztec Main Temple",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Aztec_Main_Temple",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Aztec_Main_Temple',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.AZTEC_CROCODILE_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        0.10,  0.10,  1.40,  1.40,  1.40,  2.65,  2.65,  2.65,  3.85,  3.85,
        5.00,  5.00,  6.10,  6.10,  6.10,  7.15,  7.15,  7.15,  8.15,  8.15,
        9.10,  9.10, 10.00, 10.00, 10.00, 10.85, 10.85, 10.85, 11.65, 11.65,
        12.40, 12.40, 13.10, 13.10, 13.10, 13.75, 13.75, 13.75, 14.35, 14.35,
        14.90, 14.90, 15.40, 15.40, 15.40, 15.85, 15.85, 15.85, 16.25, 16.25,
        16.60, 16.60, 16.90, 16.90, 16.90, 17.15, 17.15, 17.35, 17.35, 17.50
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.AZTEC_TEMPLE_RECRUITMENT_TIME_BONUS,
      EffectAmount.asCallbackWithLevel(
        (level) => {
          return 4 * 60 * 60 - 3 * 60 * level;
        }
      ),
      's',
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          53,57,61,65,69,73,77,81,85,89,93,97,101,105,109,113,117,121,125,129,133,137,141,145,149,153,157,161,165,169,173,177,181,185,189,193,197,201,205,209,213,217,221,225,229,233,237,241,245,249,253,257,261,265,269,273,277,281,285,289
        ],
        bronzeAge: [
          66,71,76,81,86,91,96,101,106,111,116,121,126,131,136,141,146,151,156,161,166,171,176,181,186,191,196,201,206,211,216,221,226,231,236,241,246,251,256,261,266,271,276,281,286,291,296,301,306,311,316,321,326,331,336,341,346,351,356,361
        ],
        minoanEra: [
          79,85,91,97,103,109,115,121,127,133,139,145,151,157,163,169,175,181,187,193,199,205,211,217,223,229,235,241,247,253,259,265,271,277,283,289,295,301,307,313,319,325,331,337,343,349,355,361,367,373,379,385,391,397,403,409,415,421,427,433
        ],
        classicGreece: [
          92,99,106,113,120,127,134,141,148,155,162,169,176,183,190,197,204,211,218,225,232,239,246,253,260,267,274,281,288,295,302,309,316,323,330,337,344,351,358,365,372,379,386,393,400,407,414,421,428,435,442,449,456,463,470,477,484,491,498,505
        ],
        earlyRome: [
          105,113,121,129,137,145,153,161,169,177,185,193,201,209,217,225,233,241,249,257,265,273,281,289,297,305,313,321,329,337,345,353,361,369,377,385,393,401,409,417,425,433,441,449,457,465,473,481,489,497,505,513,521,529,537,545,553,561,569,577
        ],
        romanEmpire: [
          118,127,136,145,154,163,172,181,190,199,208,217,226,235,244,253,262,271,280,289,298,307,316,325,334,343,352,361,370,379,388,397,406,415,424,433,442,451,460,469,478,487,496,505,514,523,532,541,550,559,568,577,586,595,604,613,622,631,640,649
        ],
        byzantineEra: [
          131,141,151,161,171,181,191,201,211,221,231,241,251,261,271,281,291,301,311,321,331,341,351,361,371,381,391,401,411,421,431,441,451,461,471,481,491,501,511,521,531,541,551,561,571,581,591,601,611,621,631,641,651,661,671,681,691,701,711,721
        ],
        ageOfTheFranks: [
          144,155,166,177,188,199,210,221,232,243,254,265,276,287,298,309,320,331,342,353,364,375,386,397,408,419,430,441,452,463,474,485,496,507,518,529,540,551,562,573,584,595,606,617,628,639,650,661,672,683,694,705,716,727,738,749,760,771,782,793
        ],
        feudalAge: [
          157,169,181,193,205,217,229,241,253,265,277,289,301,313,325,337,349,361,373,385,397,409,421,433,445,457,469,481,493,505,517,529,541,553,565,577,589,601,613,625,637,649,661,673,685,697,709,721,733,745,757,769,781,793,805,817,829,841,853,865
        ],
        iberianEra: [
          170,183,196,209,222,235,248,261,274,287,300,313,326,339,352,365,378,391,404,417,430,443,456,469,482,495,508,521,534,547,560,573,586,599,612,625,638,651,664,677,690,703,716,729,742,755,768,781,794,807,820,833,846,859,872,885,898,911,924,937
        ],
        kingdomOfSicily: [
          183,197,211,225,239,253,267,281,295,309,323,337,351,365,379,393,407,421,435,449,463,477,491,505,519,533,547,561,575,589,603,617,631,645,659,673,687,701,715,729,743,757,771,785,799,813,827,841,855,869,883,897,911,925,939,953,967,981,995,1009
        ],
        highMiddleAges: [
          196,211,226,241,256,271,286,301,316,331,346,361,376,391,406,421,436,451,466,481,496,511,526,541,556,571,586,601,616,631,646,661,676,691,706,721,736,751,766,781,796,811,826,841,856,871,886,901,916,931,946,961,976,991,1006,1021,1036,1051,1066,1081
        ],
        earlyGothicEra: [
          209,225,241,257,273,289,305,321,337,353,369,385,401,417,433,449,465,481,497,513,529,545,561,577,593,609,625,641,657,673,689,705,721,737,753,769,785,801,817,833,849,865,881,897,913,929,945,961,977,993,1009,1025,1041,1057,1073,1089,1105,1121,1137,1153
        ],
        lateGothicEra: [
          222,239,256,273,290,307,324,341,358,375,392,409,426,443,460,477,494,511,528,545,562,579,596,613,630,647,664,681,698,715,732,749,766,783,800,817,834,851,868,885,902,919,936,953,970,987,1004,1021,1038,1055,1072,1089,1106,1123,1140,1157,1174,1191,1208,1225
        ]
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 4
      ])
    ),
  ]),
};

export default AztecMainTemple;
